import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: `${process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING}`,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    disableCookiesUsage: true,
    extensions: [reactPlugin],
  },
});

let currentSessionId: string | undefined;

appInsights.addTelemetryInitializer((envelope) => {
  if (!currentSessionId) return;

  const tags = (envelope as { tags?: Record<string, string> }).tags ?? {};
  tags["ai.session.id"] = currentSessionId;
  (envelope as { tags?: Record<string, string> }).tags = tags;
});

appInsights.loadAppInsights();

function setAppInsightsSessionId(sessionId: string) {
  currentSessionId = sessionId;
}

export { reactPlugin, appInsights, setAppInsightsSessionId };
